module.exports = __webpack_public_path__ + "img/status-eveywhere.4d62d7d7.png";